/**
 * 
 * @copyright     (c) 2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/pages/GiftCardForm/_steps/GiftMessageStep.js
 * Created:       Tue Jan 07 2025
 * Modified By:   Greg Olive
 * Last Modified: Thu Apr 17 2025
 */

import React, { useContext} from 'react';
import { FormContext } from "@proxy/_contexts";
import {
  CardMessage,
  VideoMessage,
  Footer
} from "../_sections";

export default function GiftMessageStep({
  togglePreview
}) {

  const {
    settings,
    formData,
    fulfillmentType,
    currentStep,
    bulkOrder,
  } = useContext(FormContext);

  const shouldShowVideo = (
    (bulkOrder) ? false : (settings[fulfillmentType].giftcard.enable_video_message === true || settings[fulfillmentType].giftcard.enable_video_message === "1")
  );

  return (
    <div className={currentStep === "gift_message" && !formData.properties._gcp_send_to_self ? "gc__step gc__step_active" : "gc__step gc__step_inactive"}>
      <CardMessage />
      {(shouldShowVideo) ?
        <VideoMessage />
      : null}
      {(settings.global.appearance.form_theme === "classic" || settings.global.appearance.form_theme === "simple" || settings.global.appearance.form_theme === "crisp") && (
        <Footer togglePreview={togglePreview} />
      )}
    </div>
  );
};
